import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { alertFailure, alertSuccess } from "../../../store/actions/alert";
import CustomButton from "./Button";
import InputField from "./TextField";
import useStyles from "./style";
import CustomAccordion from "./CustomAccordion";
import { apiRoute, convertToTransaction, SendSolanaTransaction } from "../../../utils";
import { BaseRequest } from "../../../request/Request";

export default function SetOfferedLamportsRate({
  vaultAddress,
  pool_index,
  poolId,
  multiSigWallet,
  isValidVault,
  owner,
  disableButton
}: any) {
  const dispatch = useDispatch();
  const classes = useStyles();

  const [rate, setRate] = useState(0);
  const [loading, setLoading] = useState<any>(false);
  const [errors, setErrors] = useState<any>({});

  const handleRateChange = (e: any) => {
    setRate(e.target.value);
    if (rate) {
      setErrors((prevErrors : any) => {
        const { rate, ...remainingErrors } = prevErrors;
        return remainingErrors;
      });
    }
  };

  useEffect(() => {
    if(rate) {
      setErrors((prevErrors : any) => {
        const { rate, ...remainingErrors } = prevErrors;
        return remainingErrors;
      });
    }
  }, [rate])

  useEffect(() => {
    if(rate > 0) {
      setErrors((prevErrors : any) => {
        const { rate, ...remainingErrors } = prevErrors;
        return remainingErrors;
      });
    }
  }, [rate])


  const offeredLamportsRate = async () => {
    if(!window?.solana?.publicKey) {
      dispatch(alertFailure("Please Connect Solana Wallet"))
      return;
    }
    if(!pool_index) {
      dispatch(alertFailure("Pool is not deployed"))
      return;
    }
    if(!multiSigWallet) {
      dispatch(alertFailure("Please Enter MultiSig Wallet Address"))
      return;
    }
    if(!vaultAddress) {
      dispatch(alertFailure("Please Enter Vault Address"))
      return;
    }
    if(owner && !isValidVault) {
      dispatch(alertFailure("Vault Address should be the owner of Pool"));
      return;
    }
    const errors: any = {};
    if (!rate) {
      errors.rate = "Rate is required";
    }
    if (rate <= 0) {
      errors.rate = "Rate must be greater than zero";
    }
    if (Object.keys(errors).length === 0) {
      setLoading(true)
      try {
        const squads_multi_sig_address = multiSigWallet;
        const baseRequest = new BaseRequest();
        let url = apiRoute(`/solana-multisig/set-offered-lamport-rate`);
        const body = {
          squads_multi_sig_address: squads_multi_sig_address, 
          campaign_id: poolId, 
          rate: rate,
          fee_payer: window?.solana?.publicKey.toString()
      }
        const response = (await baseRequest.post(url, body)) as any;
        const result = await response.json();
        const data = result.data;
        const tx = await convertToTransaction(data)
        const sig = await SendSolanaTransaction(tx);
        dispatch(alertSuccess("Transaction Successfull"));
        setRate(0);
        setLoading(false);
      } catch (error) {
        dispatch(alertFailure("Transaction Failed"));
        setRate(0);
        setLoading(false);
      }
    } else {
      setErrors(errors);
    }
  };
  return (
    <div className={classes.spaceAbove}>
      <CustomAccordion title="Set Offered Lamports Rate">
        <div className={classes.columnFlex}>
          <InputField
            value={rate}
            onChange={handleRateChange}
            error={errors.rate}
            label="Enter Rate"
            id="rate"
            disableButton = {disableButton}
          />
          <CustomButton disableButton = {disableButton} loading = {loading} onClick={() => offeredLamportsRate()} />
        </div>
      </CustomAccordion>
    </div>
  );
}
